export const UPSERT_SUPPORT = "UPSERT_SUPPORT"
export const UPSERT_SUPPORT_SUCCESS = "UPSERT_SUPPORT_SUCCESS"
export const UPSERT_SUPPORT_FAIL = "UPSERT_SUPPORT_FAIL"

export const ADD_SUPPORT_FILE = "ADD_SUPPORT_FILE"
export const ADD_SUPPORT_FILE_SUCCESS = "ADD_SUPPORT_FILE_SUCCESS"
export const ADD_SUPPORT_FILE_FAIL = "ADD_SUPPORT_FILE_FAIL"

export const GET_SUPPORT_FILES = "GET_SUPPORT_FILES"
export const GET_SUPPORT_FILES_SUCCESS = "GET_SUPPORT_FILES_SUCCESS"
export const GET_SUPPORT_FILES_FAIL = "GET_SUPPORT_FILES_FAIL"

export const CLOSED_SUPPORT = "CLOSED_SUPPORT"
export const CLOSED_SUPPORT_SUCCESS = "CLOSED_SUPPORT_SUCCESS"
export const CLOSED_SUPPORT_FAIL = "CLOSED_SUPPORT_FAIL"

export const SWITCH_SUPPORT = "SWITCH_SUPPORT"
export const SWITCH_SUPPORT_SUCCESS = "SWITCH_SUPPORT_SUCCESS"
export const SWITCH_SUPPORT_FAIL = "SWITCH_SUPPORT_FAIL"

export const GET_LIST_SUPPORT = "GET_LIST_SUPPORT"
export const GET_LIST_SUPPORT_SUCCESS = "GET_LIST_SUPPORT_SUCCESS"
export const GET_LIST_SUPPORT_FAIL = "GET_LIST_SUPPORT_FAIL"


export const UPSERT_SUPPORT_MESSAGE = "UPSERT_SUPPORT_MESSAGE"
export const UPSERT_SUPPORT_MESSAGE_SUCCESS = "UPSERT_SUPPORT_MESSAGE_SUCCESS"
export const UPSERT_SUPPORT_MESSAGE_FAIL = "UPSERT_SUPPORT_MESSAGE_FAIL"

export const GET_LIST_SUPPORT_MESSAGE = "GET_LIST_SUPPORT_MESSAGE"
export const GET_LIST_SUPPORT_MESSAGE_SUCCESS = "GET_LIST_SUPPORT_MESSAGE_SUCCESS"
export const GET_LIST_SUPPORT_MESSAGE_FAIL = "GET_LIST_SUPPORT_MESSAGE_FAIL"

export const DELETE_SUPPORT_FILE = "DELETE_SUPPORT_FILE";
export const DELETE_SUPPORT_FILE_SUCCESS = "DELETE_SUPPORT_FILE_SUCCESS";
export const DELETE_SUPPORT_FILE_FAIL = "DELETE_SUPPORT_FILE_FAIL";


export const RESET_SUPPORT_FLAG = "RESET_SUPPORT_FLAG"
